// extracted by mini-css-extract-plugin
module.exports = {"actions":"PromotionModalActions_actions__Kl010","button":"PromotionModalActions_button__0VPa7"};